/* global axios */

const base = accountId =>
  `/api/v1/accounts/${accountId}/nexceo/ai_pending_actions`;

export default {
  stats(accountId) {
    return axios.get(`${base(accountId)}/stats`);
  },

  list(accountId, filters = {}) {
    return axios.get(base(accountId), { params: filters });
  },

  listForLead(accountId, leadId) {
    return axios.get(
      `/api/v1/accounts/${accountId}/nexceo/leads/${leadId}/ai_pending_actions`
    );
  },

  show(accountId, id) {
    return axios.get(`${base(accountId)}/${id}`);
  },

  approve(accountId, id) {
    return axios.post(`${base(accountId)}/${id}/approve`);
  },

  reject(accountId, id, reason = '') {
    return axios.post(`${base(accountId)}/${id}/reject`, { reason });
  },
};
